export const selectModalOpened = state => state.modalopened;
